@if (cmpsWithConfigs.components.length > 0) {
  <div class="mb-4 row justify-content-center">
    @if (!editConfiguration) {
        <ng-template>
            <h3 class="mb-3">Configuration</h3>
            <p class="mb-4">Select an entity to configure</p>
        </ng-template>
    }
    <div class="col-10
        {{ { condition: (deploymentService.isOguDeploymentEnabled$ | async) ?? false, output: 'p-0'} | showCase}}">
      <div ngbAccordion
        [closeOthers]="true"
        >
        @for (component of cmpsWithConfigs.components; track component.component.id; let index = $index) {
          <div ngbAccordionItem
            id="panel-component-{{ index }}"
            (hide)="onPanelChange()"
            [collapsed]="keepOpenIndex !== index"
            >
            <h3 ngbAccordionHeader>
              <button ngbAccordionButton>
                {{ component.component.name }}
                <span class="ms-4 df-subtitle">
                  {{ selectedConfig[index].name }}
                </span>
              </button>
            </h3>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="mb-5 d-inline">
                    <label [for]="'select-config-' + index" class="d-inline-block"
                      >Select configuration:</label
                      >
                      <ng-select
                        [labelForId]="'select-config-' + index"
                        class="d-inline-block ms-2 w-25"
                        [name]="'select-config-' + index"
                        [(ngModel)]="selectedConfig[index].name"
                        [items]="component.configurations | configLabels"
                        bindLabel="name"
                        bindValue="name"
                        [selectOnTab]="true"
                        [searchable]="false"
                        [clearable]="false"
                        [inputAttrs]="{ 'aria-label': 'Select the configuration', autocomplete: 'off' }"
                        (change)="onSelectConfiguration($event, component.component.id, index)">
                      </ng-select>
                    </div>
                    @if (redefinedConfigSuccess !== '' && !editConfiguration) {
                      <ngb-alert
                        dfInsertAlertIcon
                        class="d-xl-inline-flex d-none ms-4 mb-0"
                        type="success"
                        [dismissible]="false"
                        >
                        {{ redefinedConfigSuccess }}
                      </ngb-alert>
                    }
                    @if (!editConfiguration) {
                      <button
                        type="button"
                        id="create-btn"
                        class="btn btn-outline-primary right"
                        [disabled]="!(entitySelected.label | isAllowedToCreateConfiguration:user.officeId)"
                        (click)="createConfig(component, index)">
                        Create new configuration
                      </button>
                    }
                    @if (!editConfiguration && displayDynamicForm) {
                      <button
                        type="button"
                        id="copy-config-btn"
                        class="btn btn-outline-primary right me-3"
                        [disabled]="!(entitySelected.label | isAllowedToCreateConfiguration:user.officeId)"
                        (click)="copyConfig(component, index)">
                        Copy <span class="ps-2 fa-copy" aria-hidden="true"></span>
                      </button>
                    }
                    @if (displayDynamicForm) {
                      <div class="form-check form-switch right me-3">
                        <input class="form-check-input" type="checkbox" id="toggle-configuration-view"
                          [(ngModel)]="isSimpleViewActive">
                          <label for="toggle-configuration-view" class="form-check-label">
                            {{isSimpleViewActive ? 'Simple' : 'Advanced'}}
                          </label>
                        </div>
                      }
                      @if (redefinedConfigSuccess !== ''  && !editConfiguration) {
                        <ngb-alert
                          dfInsertAlertIcon
                          class="d-xl-none mt-4 mb-0"
                          type="success"
                          [dismissible]="false"
                          >
                          {{ redefinedConfigSuccess }}
                        </ngb-alert>
                      }
                      <ama-ng-app-store-parameter-container
                        [edit]="false"
                        [isSimpleView]="isSimpleViewActive"
                        [displayDynamicForm]="displayDynamicForm"
                        [configuration]="(component | getSelectedConfiguration:selectedConfigurations)">
                      </ama-ng-app-store-parameter-container>
                      @if (!editConfiguration) {
                        <div class="align-right mt-3">
                          <button
                            type="button"
                            id="edit-config-btn"
                            class="btn btn-outline-primary me-2"
                                        [disabled]="!(component |
                                    isConfigEditable:selectedConfigurations[component.component.id]!:entitySelected!:
                                    user.officeId)"
                            (click)="editConfig(component, index)">
                            Edit
                          </button>
                          <button
                            type="button"
                            id="delete-config-btn"
                            class="btn btn-outline-primary"
                                        [disabled]="!(component |
                                    isConfigEditable:selectedConfigurations[component.component.id]!:entitySelected!:
                                    user.officeId)"
                            (click)="handleDeleteApp(component)">
                            Delete
                          </button>
                        </div>
                      }
                    </ng-template>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
